import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';

import s from './NoPodBanner.module.scss';

import type { FC } from 'react';

const BANNER_KEY = 'tasksDashboard.noPodBannerDismissed';

const NoPodBanner: FC = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(BANNER_KEY) === 'true',
  );

  if (dismissed) return null;

  const handleClose = () => {
    sessionStorage.setItem(BANNER_KEY, 'true');
    setDismissed(true);
  };

  const handleAfterClose = () => {
    setDismissed(true);
  };

  return (
    <Alert
      className={s.banner}
      message={t('tasksDashboard.noPodBanner')}
      type="info"
      showIcon
      closable
      onClose={handleClose}
      afterClose={handleAfterClose}
      data-cy="no-pod-banner"
    />
  );
};

export default NoPodBanner;
